import { useQuery } from "@apollo/client";
import {
  GetRefreshedUserDataQuery,
  GetRefreshedUserDataQueryVariables,
} from "types/graphql-schema";

import { currentTiptapJWTVar } from "@cache/cache";
import { isPageHidden } from "@helpers/hooks/use-page-visible";

import getRefreshedUserDataQuery from "./graphql/get-refreshed-user-data-query";

export default function RefreshUserData() {
  useQuery<GetRefreshedUserDataQuery, GetRefreshedUserDataQueryVariables>(
    getRefreshedUserDataQuery,
    {
      pollInterval: 30 * 60 * 1000, // refresh every 30 minutes
      skipPollAttempt: isPageHidden,
      onCompleted: (response) => {
        currentTiptapJWTVar(response.me?.tiptapAiJwt || "");
      },
    }
  );
  return null;
}
